/**
 * SortIcon — the one sort affordance for a sortable column header (report
 * grids, the accounts table). Inactive columns show a muted up/down chevron;
 * the sorted column shows a `brand` arrow in its direction ("you are here").
 */
import React from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';
import { tokenVars } from '@turn-connect/ui';

export interface SortIconProps {
  active: boolean;
  direction: 'asc' | 'desc';
}

export const SortIcon: React.FC<SortIconProps> = ({ active, direction }) => {
  if (!active) {
    return <ChevronsUpDown size={12} strokeWidth={2} style={{ verticalAlign: 'middle', marginLeft: 3, color: tokenVars.text.muted }} />;
  }
  const Icon = direction === 'asc' ? ArrowUp : ArrowDown;
  return <Icon size={12} strokeWidth={2.5} style={{ verticalAlign: 'middle', marginLeft: 3, color: tokenVars.brand }} />;
};

export default SortIcon;
